export const filterReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FILTERS':
      return {
        ...state,
        filters: action.payload,
        draftFilters: action.payload,
      };
    case 'SET_DRAFT_FILTER':
      return {
        ...state,
        draftFilters: {
          ...state.draftFilters,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'APPLY_FILTERS':
      return {
        ...state,
        filters: { ...state.draftFilters },
        showFilterPanel: false,
      };
    case 'RESET_FILTERS':
      return {
        ...state,
        filters: action.payload || {},
        draftFilters: action.payload || {},
      };
    case 'SET_SHOW_FILTER_PANEL':
      return {
        ...state,
        showFilterPanel: action.payload,
        draftFilters: action.payload
          ? { ...state.filters }
          : state.draftFilters,
      };
    case 'CANCEL_FILTERS':
      return {
        ...state,
        draftFilters: { ...state.filters },
        showFilterPanel: false,
      };
    default:
      return state;
  }
};
